export class Customer {
    Id: Number;
    CustomerNo: Number;
    SurveyNo: Number;
    CustomerBranchId: Number;
    Title: Number;
    FirstName: null;
    LastName: null;
    AliasName: null;
    GenderId: Number;
    DOB: string;
    CategoryId: Number;
    Area: null;
    OccupationId: Number;
    Mobile: null;
    Email: null;
    Father: null;
    Guardian: null;
    GuardianRelationId: Number;
    MartialStatus: Number;
    Nominee: null;
    NomineeRelationId: Number;
    AadharNo: null;
    PANNo: null;
    Tax: boolean;
    BankAcNo: null;
    BankName: null;
    BankBranchName: null;
    IFSC: null;
    AgentId: Number;
    ExistingLoan: null;
    IdProof: Number;
    IdProofNo: null;
    IdProofIssued: null;
    IdProofValidity: null;
    AddressProofId: Number;
    AddressProofNo: null;
    AddressProofIssued: null;
    AddressProofValidity: null;
    AddressMobile: null;
    AddressPhone: null;
    Address: null;
    Place: null;
    PostOffice: null;
    Pincode: Number;
    Village: null;
    Panchayath: null;
    Taluk: null;
    District: Number;
    State: Number;
    CountryId: Number;
    PermanentAddress: null;
    PermanentPlace: null;
    PermanentPostOffice: null;
    PermanentPincode: Number;
    PermanentVillage: null;
    PermanentPanchayath: null;
    PermanentTaluk: null;
    PermanentDistrict: Number;
    PermanentState: Number;
    PermanentCountryId: Number;
    OfficeAddress: null;
    OfficePlace: null;
    OfficePostOffice: null;
    OfficePincode: Number;
    OfficeVillage: null;
    OfficePanchayath: null;
    OfficeTaluk: null;
    OfficeDistrict: Number;
    OfficeState: Number;
    OfficeCountryId: Number;
    NomineeAddress: null;
    NomineePlace: null;
    NomineePostOffice: null;
    NomineePincode: Number;
    NomineeVillage: null;
    NomineePanchayath: null;
    NomineeTaluk: null;
    NomineeDistrict: Number;
    NomineeState: Number;
    NomineeCountryId: Number;
    EmployeeId: Number;
    EmployeeBranchId: Number;
    CompanyId: Number;
    SaasId: string;
    CreatedDate: Date;
    ModifiedDate: Date;
    IsActive: boolean;
    Flag: Number;

    AnnualIncome: Number;
    SurveyAmount: Number;
    LoanPurposeId: 0;
    SurveyStatusId: boolean;

    IsCustomerSearch: boolean;

    IsPresentAddessSame: boolean;
    IsOfficeAddessSame: boolean;
    IsNomineeAddessSame: boolean;

    // for Report
    ReportName: string;
    BranchId: Number;
    CentreId: Number;
    LoanTypeId: Number;
    LoanCategoryId: Number;
    SchemeId: Number;

    PhotoFileName: string;
    IdProofFileName: string;
    AddressProofName: string;
    PhotoFilePath: string;
    IdProofFilePath: string;
    AddressProofFilePath: string;
}
